export const visit = (vm, at) => {
at({ "pt-br": { "upgradePointTooltip": { "upgradePageLink_jsx": function (createElement, options, props) { return createElement( options, "wrapper", null, createElement( options, "Link", props, "Fa\xE7a upgrade" ), " para realizar esta a\xE7\xE3o." ); } } } });
};